import React, { useState, useRef, useEffect } from "react";

const HILO_C = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#ffffff","#DC2626","#555555","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const HILO_S = ["#93C5FD","#FED7AA","#86EFAC","#FCD34D","#D1D5DB","#E5E7EB","#FCA5A5","#9CA3AF","#FDE68A","#C4B5FD","#FBCFE8","#A5F3FC"];
const cH  = (i) => HILO_C[(i-1)%12];
const cHS = (i) => HILO_S[(i-1)%12];

const BUF_COLORS = [
  {stroke:"rgba(99,102,241,0.5)",  bar:"rgba(99,102,241,0.5)",  text:"#6366F1"},
  {stroke:"rgba(5,150,105,0.5)",   bar:"rgba(5,150,105,0.5)",   text:"#059669"},
  {stroke:"rgba(220,38,38,0.5)",   bar:"rgba(220,38,38,0.5)",   text:"#DC2626"},
  {stroke:"rgba(202,138,4,0.5)",   bar:"rgba(202,138,4,0.5)",   text:"#CA8A04"},
  {stroke:"rgba(8,145,178,0.5)",   bar:"rgba(8,145,178,0.5)",   text:"#0891B2"},
  {stroke:"rgba(219,39,119,0.5)",  bar:"rgba(219,39,119,0.5)",  text:"#DB2777"},
];
const bc=(i)=>BUF_COLORS[i%BUF_COLORS.length];

const HILO_H=15, BUF_PAD=5, BUF_GAP=10, F_PAD=8, HDR=22, W=90;

function calcFibraH(tipo_hilos, num_buffers, hilos_por_buffer){
  const nb=num_buffers||1, hpb=hilos_por_buffer||tipo_hilos;
  let h=F_PAD*2+HDR;
  for(let b=0;b<nb;b++) h+=BUF_PAD*2+Math.min(hpb,tipo_hilos-b*hpb)*HILO_H+(b<nb-1?BUF_GAP:0);
  return h;
}

function getHiloY(elY, tipo_hilos, num_buffers, hilos_por_buffer, bi, hi){
  const hpb=hilos_por_buffer||tipo_hilos;
  let y0=F_PAD+HDR;
  for(let b=0;b<bi;b++) y0+=BUF_PAD*2+Math.min(hpb,tipo_hilos-b*hpb)*HILO_H+BUF_GAP;
  return elY+y0+BUF_PAD+hi*HILO_H+HILO_H/2;
}

function rutaEscalera(x1,y1,x2,y2,segs=null,nsegs=5){
  const dx=x2-x1, dy=y2-y1;
  const nv=Math.max(1,Math.floor((nsegs-1)/2));
  const vrs=segs?.vrs||Array.from({length:nv},(_,i)=>(i+1)/(nv+1));
  // Distribute myrs evenly between 0 and 1
  const myrs=segs?.myrs||Array.from({length:nv-1},(_,i)=>(i+1)/nv);
  let d=`M${x1},${y1}`;
  let py=y1;
  for(let i=0;i<nv;i++){
    const vx=x1+vrs[i]*dx;
    const ny=i<nv-1?y1+myrs[i]*dy:y2;
    d+=` L${vx},${py} L${vx},${ny}`;
    py=ny;
  }
  d+=` L${x2},${y2}`;
  return d;
}

function Pt({x,y,col,id,onStart,onEnd,connected,onRecon}){
  return <circle cx={x} cy={y} r={5.5}
    fill={connected?col:"#0d0d1a"} stroke={col} strokeWidth={1.5}
    style={{cursor:"crosshair"}}
    onMouseDown={e=>{
      e.stopPropagation();
      if(connected && onRecon) onRecon(id,col);
      else if(onStart) onStart(id,col);
    }}
    onMouseUp={e=>{e.preventDefault();e.stopPropagation(); if(!connected && onEnd) onEnd(id);}}/>;
}

// Dibuja un lado de fibra
function LadoFibra({id,x,y,tipo_hilos,num_buffers,hilos_por_buffer,flipped,cons,onStart,onEnd,onRecon}){
  const nb=num_buffers||1;
  const hpb=hilos_por_buffer||Math.ceil(tipo_hilos/nb);
  const ptX = flipped ? x+W : x;
  const barX = flipped ? x+W-7 : x+4;
  const lblX = flipped ? x+W-22 : x+22;
  const lblA = flipped ? "end" : "start";

  return Array.from({length:nb},(_,bi)=>{
    const hEn=Math.min(hpb,tipo_hilos-bi*hpb);
    const c=bc(bi);
    let bufY=F_PAD+HDR;
    for(let b=0;b<bi;b++) bufY+=BUF_PAD*2+Math.min(hpb,tipo_hilos-b*hpb)*HILO_H+BUF_GAP;
    return(
      <g key={bi}>
        <rect x={x+4} y={y+bufY} width={W-8} height={BUF_PAD*2+hEn*HILO_H} rx={4}
          style={{pointerEvents:"none"}} fill="rgba(17,24,39,0.95)" stroke={c.stroke} strokeWidth={1.2}/>
        <rect x={barX} y={y+bufY} width={3} height={BUF_PAD*2+hEn*HILO_H} rx={2} style={{pointerEvents:"none"}} fill={c.bar}/>
        <text style={{pointerEvents:"none"}} x={flipped?x+W-10:x+10} y={y+bufY+11} textAnchor={flipped?"end":"start"} fontSize={7} fill={c.text}>B{bi+1}</text>
        {Array.from({length:hEn},(_,hi)=>{
          const absH=bi*hpb+hi+1;
          const col=cH(absH);
          const hy=getHiloY(y,tipo_hilos,nb,hpb,bi,hi);
          const ptId=`${id}_b${bi}_h${hi}`;
          const conn=cons.some(c=>c.from===ptId||c.to===ptId);
          return(
            <g key={hi}>
              <line style={{pointerEvents:"none"}} x1={flipped?x+W-20:x+20} y1={hy} x2={flipped?x+W-4:x+4} y2={hy}
                stroke={col} strokeWidth={1} opacity={0.4}/>
              <text style={{pointerEvents:"none"}} x={lblX} y={hy+4} textAnchor={lblA} fontSize={7} fill={col}>H{absH}</text>
              <Pt x={ptX} y={hy} col={col} id={ptId}
                onStart={onStart} onEnd={onEnd} connected={conn} onRecon={onRecon}/>
            </g>
          );
        })}
      </g>
    );
  });
}

// Fibra — terminacion o desangre, con flip
function FibraComp({el, onDrag, onStart, onEnd, cons, onRecon, onFlip}){
  const {id,x,y,nombre,tipo_hilos,num_buffers,hilos_por_buffer,flipped=false,tipo} = el;
  const nb=num_buffers||1;
  const hpb=hilos_por_buffer||Math.ceil(tipo_hilos/nb);
  const H=calcFibraH(tipo_hilos,nb,hpb);
  const esDesangre = tipo==="fibra_desangre";
  // Para desangre: ancho total incluye espacio central
  const DW = esDesangre ? W*2+80 : W;

  return(
    <g onMouseDown={e=>onDrag(e,id)} style={{cursor:"grab"}}>
      {/* Manguera */}
      <rect x={x} y={y} width={DW} height={H} rx={7}
        fill="transparent" stroke="rgba(255,255,255,0.12)" strokeWidth={1.5}/>
      <text style={{pointerEvents:"none"}} x={x+DW/2} y={y+14} textAnchor="middle" fontSize={9}
        fill="rgba(255,255,255,0.25)" fontWeight="500">{nombre}</text>
      {/* Boton invertir — solo terminacion */}
      {!esDesangre&&<text style={{pointerEvents:"none"}} x={x+DW-4} y={y+14} textAnchor="end" fontSize={8} fill="#4B5563"
        style={{cursor:"pointer",userSelect:"none"}}
        onClick={e=>{e.stopPropagation();onFlip(id);}}>⇄</text>}

      {/* Lado izquierdo */}
      <LadoFibra id={`${id}_ent`} x={x} y={y} tipo_hilos={tipo_hilos}
        num_buffers={nb} hilos_por_buffer={hpb}
        flipped={esDesangre?false:flipped}
        cons={cons} onStart={onStart} onEnd={onEnd} onRecon={onRecon}/>

      {/* Lado derecho — solo desangre */}
      {esDesangre&&<LadoFibra id={`${id}_sal`} x={x+W+80} y={y} tipo_hilos={tipo_hilos}
        num_buffers={nb} hilos_por_buffer={hpb}
        flipped={true}
        cons={cons} onStart={onStart} onEnd={onEnd} onRecon={onRecon}/>}
    </g>
  );
}

// Splitter
function SplitterEl({el,onDrag,onStart,onEnd,cons,onRotate,onRecon,onSelEl,selEl}){
  const {id,x,y,tipo_sp,rotacion=0}=el;
  const ns=parseInt((tipo_sp||"1x8").split("x")[1])||8;
  const SH=Math.max(ns*18,50), SW=55;

  const getP=()=>{
    if(rotacion===0)   return `${x},${y+SH/2} ${x+SW},${y} ${x+SW},${y+SH}`;
    if(rotacion===90)  return `${x+SW/2},${y+SH} ${x},${y} ${x+SW},${y}`;
    if(rotacion===180) return `${x+SW},${y+SH/2} ${x},${y} ${x},${y+SH}`;
    return `${x+SW/2},${y} ${x},${y+SH} ${x+SW},${y+SH}`;
  };
  const eP=()=>{
    if(rotacion===0)   return {px:x,py:y+SH/2};
    if(rotacion===90)  return {px:x+SW/2,py:y+SH};
    if(rotacion===180) return {px:x+SW,py:y+SH/2};
    return {px:x+SW/2,py:y};
  };
  const sP=(i)=>{
    const t=i/(ns-1||1);
    if(rotacion===0)   return {px:x+SW,py:y+t*SH};
    if(rotacion===90)  return {px:x+t*SW,py:y};
    if(rotacion===180) return {px:x,py:y+t*SH};
    return {px:x+t*SW,py:y+SH};
  };
  const e=eP();
  const ce=cons.some(c=>c.from===`${id}_ent`||c.to===`${id}_ent`);

  return(
    <g onMouseDown={ev=>onDrag(ev,id)} onClick={ev=>{ev.stopPropagation();onSelEl&&onSelEl({tipo:'splitter',id});}} style={{cursor:"grab",outline:selEl?.id===id?'2px solid #FBBF24':'none'}}>
      <polygon points={getP()} fill="rgba(124,58,237,0.12)" stroke="#7C3AED" strokeWidth={1.8}/>
      <text style={{pointerEvents:"none"}} x={x+SW/2} y={y+SH/2-5} textAnchor="middle" fontSize={8} fill="#C4B5FD" fontWeight="500">{tipo_sp}</text>
      <text style={{pointerEvents:"none"}} x={x+SW/2} y={y+SH/2+9} textAnchor="middle" fontSize={11} fill="#7C3AED"
        style={{cursor:"pointer",userSelect:"none"}}
        onClick={ev=>{ev.stopPropagation();onRotate(id);}}>↻</text>
      <Pt x={e.px} y={e.py} col="#F59E0B" id={`${id}_ent`}
        onStart={onStart} onEnd={onEnd} connected={ce} onRecon={onRecon}/>
      {Array.from({length:ns},(_,i)=>{
        const s=sP(i);
        const cs=cons.some(c=>c.from===`${id}_s${i}`||c.to===`${id}_s${i}`);
        return(
          <g key={i}>
            <text style={{pointerEvents:"none"}} x={s.px+(rotacion===0?5:-5)} y={s.py+4}
              textAnchor={rotacion===0?"start":"end"} fontSize={7} fill="#6B7280">{i+1}</text>
            <Pt x={s.px} y={s.py} col="#F59E0B" id={`${id}_s${i}`}
              onStart={onStart} onEnd={onEnd} connected={cs} onRecon={onRecon}/>
          </g>
        );
      })}
    </g>
  );
}

// Linea con puntos de control
function getSegments(x1,y1,x2,y2,segs=null,nsegs=5){
  const dx=x2-x1, dy=y2-y1;
  const nv=Math.max(1,Math.floor((nsegs-1)/2));
  const vrs=segs?.vrs||Array.from({length:nv},(_,i)=>(i+1)/(nv+1));
  const myrs=segs?.myrs||Array.from({length:nv-1},(_,i)=>(i+1)/nv);
  const result=[];
  let py=y1;
  for(let i=0;i<nv;i++){
    const vx=x1+vrs[i]*dx;
    const ny=i<nv-1?y1+myrs[i]*dy:y2;
    if(Math.abs(ny-py)>2) result.push({id:`v${i}`,vidx:i,x1:vx,y1:Math.min(py,ny),x2:vx,y2:Math.max(py,ny),horiz:false});
    if(i<nv-1){
      const nvx=x1+vrs[i+1]*dx;
      result.push({id:`h${i}`,hidx:i,x1:vx,y1:ny,x2:nvx,y2:ny,horiz:true});
    }
    py=ny;
  }
  return result;
}

// Linea con puntos de control

function Linea({con,getPt,sel,onSel,onDragCtrl,onAddCtrl,onDragSeg,view}){
  const p1=getPt(con.from), p2=getPt(con.to);
  if(!p1||!p2) return null;
  // Apply temp segOffset for visual feedback
  const baseSegs=con.segs||null;
  const nsegs=con.nsegs||5;
  const nv=Math.max(1,Math.floor((nsegs-1)/2));
  const dx12=p2.x-p1.x||1, dy12=p2.y-p1.y||1;
  const tmpSegs=con.segOffset?(()=>{
    const vrs=[...(baseSegs?.vrs||Array.from({length:nv},(_,i)=>(i+1)/(nv+1)))];
    const myrs=[...(baseSegs?.myrs||Array.from({length:nv-1},()=>0.5))];
    const off=con.segOffset;
    if(off.id?.startsWith('v')){const vi=parseInt(off.id.slice(1));vrs[vi]=(vrs[vi]*dx12+off.dx)/dx12;}
    if(off.id?.startsWith('h')){const hi=parseInt(off.id.slice(1));myrs[hi]=(myrs[hi]*dy12+off.dy)/dy12;}
    return {vrs,myrs};
  })():baseSegs;
  const d=rutaEscalera(p1.x,p1.y,p2.x,p2.y,tmpSegs,nsegs);
  const isPunteada = con.punteada;
  const drawSegs = sel&&!isPunteada ? getSegments(p1.x,p1.y,p2.x,p2.y,tmpSegs,nsegs) : [];

  return(
    <g>
      {/* Area clicable invisible */}
      <path d={d} fill="none" stroke="transparent" strokeWidth={12}
        style={{cursor:"pointer",pointerEvents:"all"}}
        onClick={e=>{e.stopPropagation();onSel(con.id);}}/>
      {/* Linea visible */}
      <path d={d} fill="none"
        stroke={sel?"#FBBF24":isPunteada?"#374151":con.color||"#F59E0B"}
        strokeWidth={sel?2:isPunteada?1:1.5}
        strokeDasharray={isPunteada?"5,4":sel?"6,3":"none"}/>
      {/* Puntos de control - ocultar mientras drag de segmento */}
      {sel&&!isPunteada&&!con.segOffset&&(con.ctrls||[]).map((c,i)=>(
        <circle key={i} cx={c.x} cy={c.y} r={6}
          fill="#FBBF24" stroke="#fff" strokeWidth={1.5}
          style={{cursor:"grab",pointerEvents:"all"}}
          onMouseDown={e=>{e.stopPropagation();onDragCtrl(con.id,i,e);}}/>
      ))}
      {/* Segmentos arrastrables */}
      {sel&&!isPunteada&&drawSegs.map((s,i)=>(
        <line key={s.id} x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2}
          stroke="rgba(251,191,36,0.35)" strokeWidth={s.horiz?8:8}
          style={{cursor:s.horiz?"ns-resize":"ew-resize",pointerEvents:"all"}}
          onMouseDown={e=>{e.stopPropagation();onDragSeg&&onDragSeg(con.id,s,e);}}/>
      ))}
    </g>
  );
}

export default function EditorRed({mufa, fibras, onClose}){
  const [pos,    setPos]    = useState({x:30,y:30});
  const [size,   setSize]   = useState({
    w:Math.min(1100,window.innerWidth-50),
    h:Math.min(650,window.innerHeight-70)
  });
  const [view,   setView]   = useState({x:60,y:30,scale:1});
  const [elementos,  setElementos]  = useState([]);
  const [conexiones, setConexiones] = useState([]);
  const [conectando, setConectando] = useState(null);
  const [reconectando, setReconectando] = useState(null);
  const [mousePos, setMousePos] = useState({x:0,y:0});
  const [selCon,   setSelCon]   = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [selEl,    setSelEl]    = useState(null); // selected element (splitter)
  const [selGroup, setSelGroup] = useState([]); // multi-selected element ids
  const [selRect,  setSelRect]  = useState(null); // {x,y,w,h} selection rectangle
  const [modoSel,  setModoSel]  = useState(false); // selection mode active
  const [grpLineas, setGrpLineas] = useState(true);
  const [grpSplit,  setGrpSplit]  = useState(true);
  const [tipoLinea, setTipoLinea] = useState(5);
  const svgRef=useRef(null);
  const viewRef=useRef(view);
  const nxt=useRef(1);
  const selGroupRef=useRef([]);
  const elementosRef=useRef([]);
  const tipoLineaRef=useRef(5);

  useEffect(()=>{
    if(!fibras?.length) return;
    const els=[];
    const cons=[];
    let yOff=30;

    fibras.forEach((f,i)=>{
      const nb=parseInt(f.num_buffers)||1;
      const hpb=parseInt(f.hilos_por_buffer)||Math.ceil((parseInt(f.tipo_hilos)||12)/nb);
      const tipoH=parseInt(f.tipo_hilos)||12;
      const esDesangre=f.es_desangre===true;
      const elId=`f_${f.id}`;
      const H=calcFibraH(tipoH,nb,hpb);

      els.push({
        id:elId,
        tipo:esDesangre?"fibra_terminacion":"fibra_desangre",
        x:40, y:yOff,
        nombre:f.nombre,
        tipo_hilos:tipoH,
        num_buffers:nb,
        hilos_por_buffer:hpb,
        flipped:false,
        fibra:f,
      });



      // Lineas punteadas para desangre (fibra_desangre = es_desangre:false)
      if(!esDesangre){
        for(let bi=0;bi<nb;bi++){
          const hEn=Math.min(hpb,tipoH-bi*hpb);
          for(let hi=0;hi<hEn;hi++){
            const absH=bi*hpb+hi+1;
            cons.push({
              id:`pt_${f.id}_b${bi}_h${hi}`,
              from:`${elId}_ent_b${bi}_h${hi}`,
              to:`${elId}_sal_b${bi}_h${hi}`,
              color:cH(absH),
              punteada:true,
              ctrls:[],
            });
          }
        }
      }

      yOff+=H+30;
    });

    setElementos(els);
    setConexiones(cons);
  },[fibras]);

  const sc=(e)=>{
    if(!svgRef.current) return {x:0,y:0};
    const r=svgRef.current.getBoundingClientRect();
    return {
      x:(e.clientX-r.left-view.x)/view.scale,
      y:(e.clientY-r.top-view.y)/view.scale,
    };
  };

  const drag=(e,id)=>{
    if(e.button!==0) return;
    e.stopPropagation();
    const s=sc(e);
    const el=elementos.find(el=>el.id===id);
    if(!el) return;
    const ox=el.x-s.x, oy=el.y-s.y;
    const inGroup=selGroupRef.current.includes(id);
    // Store initial positions for group move
    const initPos=inGroup?elementosRef.current.filter(e=>selGroupRef.current.includes(e.id)).map(e=>({id:e.id,x:e.x,y:e.y})):[];
    const mv=(ev)=>{
      const{x,y}=sc(ev);
      if(inGroup&&initPos.length){
        const iniEl=initPos.find(p=>p.id===id);
        const dx=x+ox-(iniEl?.x||el.x), dy=y+oy-(iniEl?.y||el.y);
        setElementos(els=>els.map(e=>{
          const ini=initPos.find(p=>p.id===e.id);
          return ini?{...e,x:ini.x+dx,y:ini.y+dy}:e;
        }));
      } else {
        setElementos(els=>els.map(e=>e.id===id?{...e,x:x+ox,y:y+oy}:e));
      }
    };
    const up=()=>{window.removeEventListener("mousemove",mv);window.removeEventListener("mouseup",up);};
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };

  const panStart=(e)=>{
    // Solo pan si el click fue sobre el fondo (no sobre un elemento interactivo)
    const tag=e.target.tagName;
    if(tag==="circle") return; // punto de conexion
    setSelCon(null);
    setSelEl(null);
    setSelGroup([]);
    selGroupRef.current=[];
    if(conectando){setConectando(null);return;}
    if(reconectando){setReconectando(null);return;}
    if(modoSel){
      const startPt=sc(e);
      const startX=startPt.x, startY=startPt.y;
      let endX=startX, endY=startY;
      setSelRect({x:startX,y:startY,w:0,h:0,ltr:true});
      const mv=(ev)=>{
        const pt=sc(ev);
        endX=pt.x; endY=pt.y;
        setSelRect({
          x:Math.min(startX,endX),y:Math.min(startY,endY),
          w:Math.abs(endX-startX),h:Math.abs(endY-startY),
          ltr:endX>startX
        });
      };
      const up=()=>{
        const ltr=endX>startX;
        const rx=Math.min(startX,endX),ry=Math.min(startY,endY);
        const rw=Math.abs(endX-startX),rh=Math.abs(endY-startY);
        const selected=elementos.filter(el=>{
          const isSp=el.tipo==='splitter'||!!el.tipo_sp;
          const ns=isSp?parseInt((el.tipo_sp||'1x8').split('x')[1])||8:0;
          const elW=isSp?55:90;
          const elH=isSp?Math.max(ns*18,50):100;
          if(ltr){
            // Strict: fully inside rect
            return el.x>=rx&&el.y>=ry&&el.x+elW<=rx+rw&&el.y+elH<=ry+rh;
          } else {
            // Loose: touches rect
            return el.x+elW>=rx&&el.x<=rx+rw&&el.y+elH>=ry&&el.y<=ry+rh;
          }
        }).map(el=>el.id);
        setSelGroup(selected);
        setSelRect(null);
        window.removeEventListener("mousemove",mv);
        window.removeEventListener("mouseup",up);
      };
      window.addEventListener("mousemove",mv);
      window.addEventListener("mouseup",up);
      return;
    }
    const sx=e.clientX-view.x, sy=e.clientY-view.y;
    const mv=(ev)=>setView(v=>({...v,x:ev.clientX-sx,y:ev.clientY-sy}));
    const up=()=>{window.removeEventListener("mousemove",mv);window.removeEventListener("mouseup",up);};
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };

  useEffect(()=>{viewRef.current=view;},[view]);
  useEffect(()=>{elementosRef.current=elementos;},[elementos]);


  // Selection mode - capture all mouse events
  useEffect(()=>{
    if(!modoSel||!svgRef.current) return;
    const svg=svgRef.current;
    let startX,startY,endX,endY,dragging=false;
    const down=(e)=>{
      e.preventDefault();
      e.stopPropagation();
      const r=svg.getBoundingClientRect();
      startX=(e.clientX-r.left-viewRef.current.x)/viewRef.current.scale;
      startY=(e.clientY-r.top-viewRef.current.y)/viewRef.current.scale;
      endX=startX;endY=startY;
      dragging=true;
      setSelRect({x:startX,y:startY,w:0,h:0,ltr:true});
    };
    const move=(e)=>{
      if(!dragging) return;
      const r=svg.getBoundingClientRect();
      endX=(e.clientX-r.left-viewRef.current.x)/viewRef.current.scale;
      endY=(e.clientY-r.top-viewRef.current.y)/viewRef.current.scale;
      setSelRect({
        x:Math.min(startX,endX),y:Math.min(startY,endY),
        w:Math.abs(endX-startX),h:Math.abs(endY-startY),
        ltr:endX>startX
      });
    };
    const up=(e)=>{
      if(!dragging) return;
      dragging=false;
      const ltr=endX>startX;
      const rx=Math.min(startX,endX),ry=Math.min(startY,endY);
      const rw=Math.abs(endX-startX),rh=Math.abs(endY-startY);
      setElementos(els=>{
        const selected=els.filter(el=>{
          const isSp=el.tipo==='splitter';
          const ns=isSp?parseInt((el.tipo_sp||'1x8').split('x')[1])||8:0;
          const elW=isSp?55:90;
          const elH=isSp?Math.max(ns*18,50):120;
          if(ltr) return el.x>=rx&&el.y>=ry&&el.x+elW<=rx+rw&&el.y+elH<=ry+rh;
          else return el.x+elW>=rx&&el.x<=rx+rw&&el.y+elH>=ry&&el.y<=ry+rh;
        }).map(el=>el.id);
        setSelGroup(selected);
        return els;
      });
      setSelRect(null);
    };
    svg.addEventListener('mousedown',down,true);
    window.addEventListener('mousemove',move);
    window.addEventListener('mouseup',up);
    return()=>{
      svg.removeEventListener('mousedown',down,true);
      window.removeEventListener('mousemove',move);
      window.removeEventListener('mouseup',up);
    };
  },[modoSel]);

  const wheel=(e)=>{
    e.preventDefault();
    e.stopPropagation();
    setView(v=>({...v,scale:Math.max(0.2,Math.min(3,v.scale*(e.deltaY>0?0.9:1.1)))}));
  };

  // Block browser scroll when mouse inside editor
  useEffect(()=>{
    const el=svgRef.current;
    if(!el) return;
    el.addEventListener('wheel', wheel, {passive:false});
    return ()=>el.removeEventListener('wheel', wheel);
  },[view]);

  const onStart=(ptId,col)=>{
    if(!ptId) return;
    setConectando({from:ptId,color:col,nsegs:tipoLineaRef.current||5});
  };

  const onEnd=(ptId)=>{
    if(!ptId) return;
    if(reconectando){
      setConexiones(cs=>cs.map(c=>
        c.id===reconectando.conId?{...c,[reconectando.lado]:ptId}:c
      ));
      setReconectando(null);
      return;
    }
    if(conectando&&conectando.from!==ptId){
      setConexiones(cs=>[...cs,{
        id:`c_${Date.now()}`,
        from:conectando.from,
        to:ptId,
        color:conectando.color,
        punteada:false,
        ctrls:[],
        nsegs:conectando.nsegs||5,
      }]);
    }
    setConectando(null);
  };

  const onRecon=(ptId,col)=>{
    if(!ptId) return;
    const con=conexiones.find(c=>c.from===ptId||c.to===ptId);
    if(!con) return;
    setReconectando({conId:con.id,lado:con.from===ptId?"from":"to",color:col});
  };

  const onDragSeg=(conId,seg,e)=>{
    const startX=e.clientX, startY=e.clientY;
    const curCon=conexiones.find(c=>c.id===conId);
    const nsegsC=curCon?.nsegs||5;
    const nvC=Math.max(1,Math.floor((nsegsC-1)/2));
    const baseVrs=[...(curCon?.segs?.vrs||Array.from({length:nvC},(_,i)=>(i+1)/(nvC+1)))];
    const baseMyrs=[...(curCon?.segs?.myrs||Array.from({length:nvC-1},()=>0.5))];
    const mv=(ev)=>{
      const dx=(ev.clientX-startX)/view.scale;
      const dy=(ev.clientY-startY)/view.scale;
      setConexiones(cs=>cs.map(c=>c.id!==conId?c:{...c,segOffset:{id:seg.id,dx,dy}}));
    };
    const up=(ev)=>{
      const dx=(ev.clientX-startX)/view.scale;
      const dy=(ev.clientY-startY)/view.scale;
      setConexiones(cs=>cs.map(c=>{
        if(c.id!==conId) return c;
        const p1c=getPt(c.from),p2c=getPt(c.to);
        if(!p1c||!p2c) return {...c,segOffset:null};
        const dxc=p2c.x-p1c.x||1, dyc=p2c.y-p1c.y||1;
        const newVrs=[...baseVrs], newMyrs=[...baseMyrs];
        if(seg.id?.startsWith('v')){const vi=parseInt(seg.id.slice(1));newVrs[vi]=(baseVrs[vi]*dxc+dx)/dxc;}
        if(seg.id?.startsWith('h')){const hi=parseInt(seg.id.slice(1));newMyrs[hi]=(baseMyrs[hi]*dyc+dy)/dyc;}
        return {...c,segs:{vrs:newVrs,myrs:newMyrs},segOffset:null};
      }));
      window.removeEventListener("mousemove",mv);
      window.removeEventListener("mouseup",up);
    };
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };
  const onDragCtrl=(conId,ci,e)=>{
    const mv=(ev)=>{
      const{x,y}=sc(ev);
      setConexiones(cs=>cs.map(c=>{
        if(c.id!==conId) return c;
        const ctrls=[...(c.ctrls||[])];
        ctrls[ci]={x,y};
        return {...c,ctrls};
      }));
    };
    const up=()=>{window.removeEventListener("mousemove",mv);window.removeEventListener("mouseup",up);};
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };

  const onAddCtrl=(conId,pt)=>{
    const con=conexiones.find(c=>c.id===conId);
    if(!con) return;
    const p1=getPt(con.from), p2=getPt(con.to);
    if(!p1||!p2) return;
    const wps=con.waypoints||[];
    const pts=[p1,...wps,p2];
    // Insert new waypoint between closest pair
    let bestIdx=0, bestDist=Infinity;
    for(let i=0;i<pts.length-1;i++){
      const dist=Math.abs(pt.x-(pts[i].x+pts[i+1].x)/2)+Math.abs(pt.y-(pts[i].y+pts[i+1].y)/2);
      if(dist<bestDist){bestDist=dist;bestIdx=i;}
    }
    const newWps=[...wps.slice(0,bestIdx),{x:pt.x,y:pt.y},...wps.slice(bestIdx)];
    setConexiones(cs=>cs.map(c=>c.id===conId?{...c,waypoints:newWps}:c));
  };

  const onFlip=(id)=>{
    setElementos(els=>els.map(e=>e.id===id?{...e,flipped:!e.flipped}:e));
  };

  // Teclado: Delete elimina linea, ESC cancela conexion
  useEffect(()=>{
    const k=(e)=>{
      if(e.key==="Escape"){
        setConectando(null);
        setReconectando(null);
        setSelEl(null);
        setSelGroup([]);
        selGroupRef.current=[];
      }
      if(e.key==="Delete"||e.key==="Backspace"){
        if(selCon){
          setConexiones(cs=>cs.filter(c=>c.id!==selCon));
          setSelCon(null);
        }
        if(selEl&&selEl.tipo==="splitter"){
          setElementos(els=>els.filter(e=>e.id!==selEl.id));
          // Remove all conexiones connected to this splitter
          setConexiones(cs=>cs.filter(c=>
            !c.from.startsWith(selEl.id+'_') && !c.to.startsWith(selEl.id+'_')
          ));
          setSelEl(null);
        }
      }
    };
    window.addEventListener("keydown",k);
    return ()=>window.removeEventListener("keydown",k);
  },[selCon,selEl]);

  const getPt=(ptId)=>{
    if(!ptId) return null;
    const el=elementos.find(e=>ptId.startsWith(e.id+"_"));
    if(!el) return null;
    const suf=ptId.slice(el.id.length+1);
    if(!suf) return null;

    if(el.tipo==="fibra_terminacion"||el.tipo==="fibra_desangre"){
      // suf puede ser: ent_b0_h0 o sal_b0_h0 o b0_h0
      const parts=suf.split("_");
      if(parts.length<2) return null;
      let lado="ent", bStr, hStr;
      if(parts[0]==="ent"||parts[0]==="sal"){
        lado=parts[0]; bStr=parts[1]||"b0"; hStr=parts[2]||"h0";
      } else {
        bStr=parts[0]||"b0"; hStr=parts[1]||"h0";
      }
      const bi=parseInt(bStr.replace("b","")||"0");
      const hi=parseInt(hStr.replace("h","")||"0");
      const hy=getHiloY(el.y,el.tipo_hilos,el.num_buffers||1,el.hilos_por_buffer||el.tipo_hilos,bi,hi);
      let px;
      if(el.tipo==="fibra_desangre"){
        px = lado==="sal" ? el.x+W+80+W : el.x; // sal=derecha, ent=izquierda
      } else {
        px = el.flipped ? el.x+W : el.x;
      }
      return {x:px, y:hy};
    }

    // splitter
    if(el.tipo==="splitter"){
      const ns=parseInt((el.tipo_sp||"1x8").split("x")[1])||8;
      const SH=Math.max(ns*18,50), SW=55, rot=el.rotacion||0;
      if(suf==="ent"){
        if(rot===0) return {x:el.x,y:el.y+SH/2};
        if(rot===90) return {x:el.x+SW/2,y:el.y+SH};
        if(rot===180) return {x:el.x+SW,y:el.y+SH/2};
        return {x:el.x+SW/2,y:el.y};
      }
      const i=parseInt(suf.replace("s","")||"0");
      if(isNaN(i)) return null;
      const t=i/(ns-1||1);
      if(rot===0) return {x:el.x+SW,y:el.y+t*SH};
      if(rot===90) return {x:el.x+t*SW,y:el.y};
      if(rot===180) return {x:el.x,y:el.y+t*SH};
      return {x:el.x+t*SW,y:el.y+SH};
    }
    return null;
  };

  const addSp=(tipo)=>{
    setElementos(els=>[...els,{
      id:`sp_${nxt.current++}`,tipo:"splitter",
      x:250,y:80,tipo_sp:tipo,rotacion:0
    }]);
  };
  const rotSp=(id)=>setElementos(els=>els.map(e=>
    e.id===id?{...e,rotacion:((e.rotacion||0)+90)%360}:e
  ));

  const fitToScreen=()=>{
    if(!elementos.length) return;
    const xs=elementos.map(e=>e.x), ys=elementos.map(e=>e.y);
    const minX=Math.min(...xs)-20, minY=Math.min(...ys)-20;
    const maxX=Math.max(...xs.map((x,i)=>x+(elementos[i].tipo==="fibra_desangre"?W*2+80:W)))+20;
    const maxY=Math.max(...ys.map((y,i)=>y+calcFibraH(elementos[i].tipo_hilos||12,elementos[i].num_buffers||1,elementos[i].hilos_por_buffer||12)))+20;
    const canvasW=size.w-80, canvasH=size.h-40;
    const scaleX=canvasW/(maxX-minX), scaleY=canvasH/(maxY-minY);
    const scale=Math.min(scaleX,scaleY,2);
    setView({x:-minX*scale+20, y:-minY*scale+20, scale});
  };

  const autoOrganizar=()=>{
    // Group connections by their from/to element pair
    const grupos={};
    conexiones.filter(c=>!c.punteada).forEach(c=>{
      const key=[c.from.split('_')[1],c.to.split('_')[1]].sort().join('-');
      if(!grupos[key]) grupos[key]=[];
      grupos[key].push(c.id);
    });
    setConexiones(cs=>{
      const updated=[...cs];
      const SEP=4;
      Object.values(grupos).forEach(ids=>{
        if(ids.length<2) return;
        // Distribute myr symmetrically
        const n=ids.length;
        ids.forEach((id,i)=>{
          const idx=updated.findIndex(c=>c.id===id);
          if(idx<0) return;
          const con=updated[idx];
          const nsegsA=con.nsegs||5;
          const nvA=Math.max(1,Math.floor((nsegsA-1)/2));
          const t=n===1?0.5:i/(n-1);
          const centerOffset=(i-(n-1)/2)*SEP;
          const p1a=getPt(con.from),p2a=getPt(con.to);
          const dya=(p2a?.y||0)-(p1a?.y||1)||1;
          const dxa=(p2a?.x||0)-(p1a?.x||1)||1;
          const vrs=Array.from({length:nvA},(_,j)=>(j+1)/(nvA+1)+(centerOffset/dxa)*0.6);
          const myrs=Array.from({length:nvA-1},()=>0.5+centerOffset/dya);
          updated[idx]={...updated[idx], segs:{vrs,myrs}};
        });
      });
      return updated;
    });
  };

  const panelDrag=(e)=>{
    if(fullscreen) return;
    const sx=e.clientX-pos.x, sy=e.clientY-pos.y;
    const mv=(ev)=>setPos({x:ev.clientX-sx,y:ev.clientY-sy});
    const up=()=>{window.removeEventListener("mousemove",mv);window.removeEventListener("mouseup",up);};
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };

  const resizeDrag=(e)=>{
    if(fullscreen) return;
    e.stopPropagation();
    const sx=e.clientX, sy=e.clientY, sw=size.w, sh=size.h;
    const mv=(ev)=>setSize({
      w:Math.max(600,sw+ev.clientX-sx),
      h:Math.max(350,sh+ev.clientY-sy)
    });
    const up=()=>{window.removeEventListener("mousemove",mv);window.removeEventListener("mouseup",up);};
    window.addEventListener("mousemove",mv);
    window.addEventListener("mouseup",up);
  };

  const modo=reconectando?"reconectando":conectando?"conectando":"normal";
  const TOOLS=[
    {id:"1x2",l:"SP 1x2"},{id:"1x4",l:"SP 1x4"},
    {id:"1x8",l:"SP 1x8"},{id:"1x16",l:"SP 1x16"},{id:"1x32",l:"SP 1x32"},
  ];

  const selConObj=conexiones.find(c=>c.id===selCon);

  return(
    <div style={{
      position:"fixed",
      left:fullscreen?0:pos.x, top:fullscreen?0:pos.y,
      width:fullscreen?"100vw":size.w, height:fullscreen?"100vh":size.h,
      background:"#0d0d1a",
      border:fullscreen?"none":"1.5px solid #1F2937",
      borderRadius:fullscreen?0:10,
      zIndex:1000,
      display:"flex",flexDirection:"column",
      boxShadow:"0 8px 40px rgba(0,0,0,0.9)",overflow:"hidden"}}>

      {/* Header */}
      <div onMouseDown={panelDrag} style={{background:"#111827",padding:"5px 12px",cursor:"move",
        display:"flex",justifyContent:"space-between",alignItems:"center",
        borderBottom:"1px solid #1F2937",userSelect:"none",flexShrink:0}}>
        <span style={{color:"#C4B5FD",fontWeight:600,fontSize:12}}>
          ✎ Editor — {mufa?.nombre||"Mufa"}
        </span>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          {selCon&&<button
            onClick={()=>{setConexiones(cs=>cs.filter(c=>c.id!==selCon));setSelCon(null);}}
            style={{background:"rgba(239,68,68,0.15)",color:"#F87171",
              border:"1px solid #F87171",borderRadius:4,padding:"2px 8px",
              fontSize:10,cursor:"pointer"}}>
            🗑 {selConObj?.punteada?"Cortar hilo":"Eliminar línea"}
          </button>}
          <button onClick={fitToScreen}
            style={{background:"#1F2937",color:"#6B7280",border:"1px solid #374151",
              borderRadius:4,padding:"2px 7px",fontSize:10,cursor:"pointer"}}>
            {Math.round(view.scale*100)}% ⊡
          </button>
          <button onClick={()=>setView({x:60,y:30,scale:1})}
            style={{background:"#1F2937",color:"#6B7280",border:"none",
              borderRadius:4,padding:"2px 7px",fontSize:10,cursor:"pointer"}}>⊙</button>
          <button onClick={()=>setFullscreen(f=>!f)}
            style={{background:fullscreen?"#7C3AED":"#1F2937",color:fullscreen?"#fff":"#6B7280",
              border:"1px solid #374151",borderRadius:4,padding:"2px 7px",fontSize:10,cursor:"pointer"}}>
            {fullscreen?"⊠":"⛶"}
          </button>
          <button onClick={onClose}
            style={{background:"rgba(239,68,68,0.15)",color:"#F87171",
              border:"1px solid rgba(239,68,68,0.3)",borderRadius:4,
              padding:"2px 8px",fontSize:11,cursor:"pointer"}}>✕</button>
        </div>
      </div>

      <div style={{display:"flex",flex:1,overflow:"hidden"}}>
        {/* Panel herramientas */}
        <div style={{width:76,background:"#0a0a12",borderRight:"1px solid #1F2937",
          padding:"6px 4px",display:"flex",flexDirection:"column",gap:4,flexShrink:0,overflowY:"auto"}}>

          {/* Grupo Líneas */}
          <div>
            <button onClick={()=>setGrpLineas(v=>!v)}
              style={{width:"100%",background:"#111827",color:"#6366F1",
                border:"1px solid #1F2937",borderRadius:4,padding:"3px 4px",
                cursor:"pointer",fontSize:8,display:"flex",justifyContent:"space-between"}}>
              <span>Líneas</span><span>{grpLineas?"▾":"▸"}</span>
            </button>
            {grpLineas&&(
              <div style={{display:"flex",flexDirection:"column",gap:2,marginTop:2}}>
                {[[3,"3 seg"],[5,"5 seg"],[7,"7 seg"],[9,"9 seg"]].map(([n,l])=>(
                  <button key={n} onClick={()=>{setTipoLinea(n);tipoLineaRef.current=n;setGrpLineas(false);}}
                    style={{background:tipoLinea===n?"rgba(99,102,241,0.3)":"#111827",
                      color:tipoLinea===n?"#A5B4FC":"#9CA3AF",
                      border:tipoLinea===n?"1px solid #6366F1":"1px solid #1F2937",
                      borderRadius:4,padding:"4px 2px",cursor:"pointer",fontSize:7,textAlign:"center"}}>
                    ╌╌╌<br/>{l}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Grupo Splitters */}
          <div>
            <button onClick={()=>setGrpSplit(v=>!v)}
              style={{width:"100%",background:"#111827",color:"#7C3AED",
                border:"1px solid #1F2937",borderRadius:4,padding:"3px 4px",
                cursor:"pointer",fontSize:8,display:"flex",justifyContent:"space-between"}}>
              <span>Splitter</span><span>{grpSplit?"▾":"▸"}</span>
            </button>
            {grpSplit&&(
              <div style={{display:"flex",flexDirection:"column",gap:2,marginTop:2}}>
                {[["1x2","1x2"],["1x4","1x4"],["1x8","1x8"],["1x16","1x16"],["1x32","1x32"]].map(([id,l])=>(
                  <button key={id} onClick={()=>{addSp(id);setGrpSplit(false);}}
                    style={{background:"#111827",color:"#9CA3AF",
                      border:"1px solid #1F2937",borderRadius:4,
                      padding:"4px 2px",cursor:"pointer",fontSize:7,textAlign:"center"}}>
                    ▷ {l}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Botón Auto */}
          <button onClick={autoOrganizar}
            style={{background:"rgba(99,102,241,0.15)",color:"#6366F1",
              border:"1px solid #6366F1",borderRadius:4,padding:"4px 2px",
              cursor:"pointer",fontSize:7,textAlign:"center"}}>
            ⚡ Auto
          </button>

          {/* Modo seleccion */}
          <button onClick={()=>{setModoSel(v=>!v);setSelGroup([]);}}
            style={{background:modoSel?"rgba(99,102,241,0.4)":"#111827",
              color:modoSel?"#A5B4FC":"#6B7280",
              border:modoSel?"1px solid #6366F1":"1px solid #1F2937",
              borderRadius:4,padding:"4px 2px",cursor:"pointer",fontSize:7,textAlign:"center"}}>
            ⬚ Sel
          </button>

          {/* Zoom */}
          <div style={{borderTop:"1px solid #1F2937",paddingTop:4,
            display:"flex",flexDirection:"column",gap:2}}>
            <button onClick={()=>setView(v=>({...v,scale:Math.min(3,v.scale*1.2)}))}
              style={{background:"#111827",color:"#6B7280",border:"1px solid #1F2937",
                borderRadius:4,padding:"3px",cursor:"pointer",fontSize:13}}>＋</button>
            <button onClick={()=>setView(v=>({...v,scale:Math.max(0.2,v.scale*0.8)}))}
              style={{background:"#111827",color:"#6B7280",border:"1px solid #1F2937",
                borderRadius:4,padding:"3px",cursor:"pointer",fontSize:13}}>－</button>
          </div>
        </div>

        {/* Canvas SVG */}
        <div style={{flex:1,overflow:"hidden",position:"relative"}}>
          <svg ref={svgRef} width="100%" height="100%"
            style={{background:"#0d0d1a",userSelect:"none",cursor:modoSel?"crosshair":"grab"}}
            onMouseDown={panStart}
            onMouseMove={e=>{const{x,y}=sc(e);setMousePos({x,y});}}>
            <defs>
              <pattern id="eg" width={20*view.scale} height={20*view.scale}
                patternUnits="userSpaceOnUse"
                x={view.x%(20*view.scale)} y={view.y%(20*view.scale)}>
                <path d={`M ${20*view.scale} 0 L 0 0 0 ${20*view.scale}`}
                  fill="none" stroke="#12121f" strokeWidth="0.8"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#eg)"/>

            {modoSel&&<rect x="0" y="0" width="100%" height="100%"
                fill="transparent" style={{cursor:"crosshair",pointerEvents:"all"}}
                onMouseDown={e=>{e.stopPropagation();const pt=sc(e);setSelRect({x:pt.x,y:pt.y,w:0,h:0,ltr:true,sx:pt.x,sy:pt.y});}}
                onMouseMove={e=>{if(!selRect) return;const pt=sc(e);setSelRect(r=>r?{...r,x:Math.min(r.sx,pt.x),y:Math.min(r.sy,pt.y),w:Math.abs(pt.x-r.sx),h:Math.abs(pt.y-r.sy),ltr:pt.x>r.sx}:null);}}
                onMouseUp={e=>{
                  if(!selRect) return;
                  const rx=selRect.x,ry=selRect.y,rw=selRect.w,rh=selRect.h,ltr=selRect.ltr;
                  const ids=elementos.filter(el=>{
                    const isSp=el.tipo==="splitter";
                    const ns=isSp?parseInt((el.tipo_sp||"1x8").split("x")[1])||8:0;
                    const elW=isSp?55:90,elH=isSp?Math.max(ns*18,50):120;
                    if(ltr) return el.x>=rx&&el.y>=ry&&el.x+elW<=rx+rw&&el.y+elH<=ry+rh;
                    return el.x+elW>=rx&&el.x<=rx+rw&&el.y+elH>=ry&&el.y<=ry+rh;
                  }).map(el=>el.id);
                  selGroupRef.current=ids;
                  setSelGroup(ids);
                  setSelRect(null);
                  setModoSel(false);
                }}/>}
            <g transform={`translate(${view.x},${view.y}) scale(${view.scale})`}>


              {/* Linea temporal al conectar */}
              {(conectando||reconectando)&&(()=>{
                const pid=conectando?.from||(
                  reconectando&&conexiones.find(c=>c.id===reconectando.conId)
                    ?.[reconectando.lado]
                );
                const p=pid?getPt(pid):null;
                if(!p) return null;
                return <line x1={p.x} y1={p.y} x2={mousePos.x} y2={mousePos.y}
                  stroke={conectando?.color||reconectando?.color||"#F59E0B"}
                  strokeWidth={1.5} strokeDasharray="5,3"/>;
              })()}

              {/* Elementos */}
              {elementos.map(el=>{
                const props={
                  key:el.id, el,
                  onDrag:drag,
                  onStart, onEnd,
                  cons:conexiones,
                  onRecon,
                  onFlip,
                };
                if(el.tipo==="fibra_terminacion"||el.tipo==="fibra_desangre")
                  return <g key={el.id} style={{filter:selGroup.includes(el.id)?"drop-shadow(0 0 4px #6366F1)":"none"}}>
                    <FibraComp {...props}/>
                  </g>;
                if(el.tipo==="splitter")
                  return <SplitterEl {...props} onRotate={rotSp} onSelEl={setSelEl} selEl={selEl}/>;
                return null;
              })}
              {/* Punteadas */}
              {conexiones.filter(c=>c.punteada).map(c=>(
                <Linea key={c.id} con={c} getPt={getPt}
                  sel={selCon===c.id} onSel={setSelCon}
                  onDragCtrl={onDragCtrl} onAddCtrl={onAddCtrl}
                  onDragSeg={onDragSeg} view={view}/>
              ))}
              {/* Conexiones normales encima */}
              {conexiones.filter(c=>!c.punteada).map(c=>(
                <Linea key={c.id} con={c} getPt={getPt}
                  sel={selCon===c.id} onSel={setSelCon}
                  onDragCtrl={onDragCtrl} onAddCtrl={onAddCtrl}
                  onDragSeg={onDragSeg} view={view}/>
              ))}
              {/* Linea temporal encima de todo */}
              {(conectando||reconectando)&&(()=>{
                const pid=conectando?.from||(reconectando&&conexiones.find(c=>c.id===reconectando.conId)?.[reconectando.lado]);
                const p=pid?getPt(pid):null;
                if(!p) return null;
                return <line key="tmp" x1={p.x} y1={p.y} x2={mousePos.x} y2={mousePos.y}
                  stroke={conectando?.color||reconectando?.color||"#F59E0B"}
                  strokeWidth={2} strokeDasharray="5,3"/>;
              })()}


              {/* Rectangulo de seleccion */}
              {selRect&&<rect
                x={selRect.x} y={selRect.y}
                width={selRect.w} height={selRect.h}
                fill={selRect.ltr?"rgba(99,102,241,0.08)":"rgba(251,191,36,0.08)"}
                stroke={selRect.ltr?"#6366F1":"#FBBF24"}
                strokeWidth={1} strokeDasharray="4,3"
                style={{pointerEvents:"none"}}/>}
            </g>
          </svg>

          {/* Info estado */}
          <div style={{position:"absolute",bottom:5,left:8,fontSize:8,color:"#374151",
            background:"rgba(0,0,0,0.7)",padding:"2px 8px",borderRadius:4}}>
            {modo==="conectando"
              ?"Clic en punto destino · Fondo=cancelar"
              :modo==="reconectando"
              ?"Clic en nuevo destino para redirigir"
              :selCon
              ?`${selConObj?.punteada?"Hilo continuo":"Línea"} selec. · Delete=eliminar${!selConObj?.punteada?" · Doble clic=punto control":""}`
              :"Arrastra · Scroll=zoom · Fondo=mover · Clic línea=seleccionar · ⇄=invertir fibra"}
          </div>
        </div>
      </div>

      {/* Resize handle */}
      <div onMouseDown={resizeDrag} style={{position:"absolute",bottom:0,right:0,
        width:14,height:14,cursor:"se-resize",
        background:"linear-gradient(135deg,transparent 50%,#1F2937 50%)",
        borderRadius:"0 0 10px 0"}}/>
    </div>
  );
}
